
const pollsRoutes = {
  path: "polls",

  // Lazy-load the layout
  lazy: async () => {
    const mod = await import("components/UI/PollsLayout");
    const PollsLayout = mod.default;
    return { Component: PollsLayout };
  },

  children: [
    {
      index: true,
      lazy: async () => {
        const mod = await import("views/Admin/Polls");
        const Polls = mod.default;
        return { Component: Polls };
      },
    },
  ],
};

export default pollsRoutes;
